<template>
    <div>
        <div class="section first">
            <div class="col-8 float-left ">
                <h1>엔닷캐드<br>광고 문의</h1>
                <p>엔닷캐드 광고를 통해 다양한 지역, 다양한 나라에 있는 사람들에게<br>도달해보세요. 이미지, 동영상에 구애받지 않고 다섯개의 각기<br>다른 종류를 지원합니다. 여러분의 광고에 날개를 달아드릴게요!</p>
                <button @click="scrollToElement">문의하러 가기&nbsp;&nbsp;&nbsp;&nbsp;<i class="fas fa-long-arrow-alt-right"></i></button>
            </div>
            <div class="col-4 float-left">
                <img class="" src="data:image/svg+xml;base64,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" />
            </div>
        </div>

        <div class="section second">
            <h2>왜 엔닷캐드를 선택해야 할까요?</h2>
            <div class="container">
                <div class="item sm">
                    <div class="numb">1</div>
                    <img src="data:image/svg+xml;base64,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" />                    
                    <h3>정교한 타겟팅</h3>
                    <ul>
                        <li>17개 시·도 지역별 광고 노출</li>
                        <li>학교, 기관, 개인 메이커 등 타겟별 <br>광고 노출</li>
                    </ul>
                </div>
                <div class="item bg">
                    <div class="numb">2</div>
                    <img src="data:image/svg+xml;base64,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" />
                    <h3>강력한 매체 파워</h3>
                    <ul>
                        <li>엔닷캐드 월 평균 성장률 300%</li>
                        <li>유저 1인당 평균 사용시간 1시간 이상</li>
                        <li>대한민국을 비롯해 미국, 영국, 프랑스, <br>스페인, 독일, 일본, 중국 등 글로벌 성장 플랫폼</li>
                    </ul>
                </div>
                <div class="item sm">
                    <div class="numb">3</div>
                    <!-- <img src="data:image/svg+xml;base64,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" /> -->
                    <img src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNTEyIDUxMiIgaGVpZ2h0PSI1MTIiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB3aWR0aD0iNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnPjxnPjxnPjxwYXRoIGQ9Im0wIDMxLjkzNmg1MTJ2NDQ4LjEyOWgtNTEyeiIgZmlsbD0iI2ZmZjZjYyIvPjxwYXRoIGQ9Im00NzAuNzkzIDMxLjkzNmg0MS4yMDd2NDQ4LjEyOWgtNDEuMjA3eiIgZmlsbD0iI2ZmZjFiNSIvPjxwYXRoIGQ9Im0wIDMxLjkzNmg1MTJ2NTguODkyaC01MTJ6IiBmaWxsPSIjN2I3YjdmIi8+PHBhdGggZD0ibTQ3MC43OTMgMzEuOTM2aDQxLjIwN3Y1OC44OTJoLTQxLjIwN3oiIGZpbGw9IiM2YjZiNzMiLz48L2c+PGc+PHBhdGggZD0ibTU4LjcyIDE0MC44MjJoNzcuNjQ4djE3NS41NmgtNzcuNjQ4eiIgZmlsbD0iI2ZkMCIvPjxwYXRoIGQ9Im05Ny4yMjEgMTQwLjgyMmgzOS4xNDd2MTc1LjU2aC0zOS4xNDd6IiBmaWxsPSIjZjdkMjAwIi8+PHBhdGggZD0ibTU4LjcyIDM0OC40MjhoNzcuNjQ4djc2LjUyMmgtNzcuNjQ4eiIgZmlsbD0iIzAwY2ZlOSIvPjxwYXRoIGQ9Im0xNzEuMjUxIDE0MC44MjJoMjc3Ljk4NHY5OC4yNTFoLTI3Ny45ODR6IiBmaWxsPSIjMDBjZmU5Ii8+PHBhdGggZD0ibTQwOC4wMjggMTQwLjgyMmg0MS4yMDd2OTguMjUyaC00MS4yMDd6IiBmaWxsPSIjMDBiZmQ2Ii8+PHBhdGggZD0ibTE3MS4yNTEgMjcxLjkwNmgxMjAuODA1djE1My4wNDNoLTEyMC44MDV6IiBmaWxsPSIjZmY3ZGU5Ii8+PHBhdGggZD0ibTI1MC44NDkgMjcxLjkwNmg0MS4yMDd2MTUzLjA0M2gtNDEuMjA3eiIgZmlsbD0iI2ZmNWVlNCIvPjxwYXRoIGQ9Im0zMjguNDMgMjcxLjkwNmgxMjAuODA1djc2LjUyMmgtMTIwLjgwNXoiIGZpbGw9IiM4MGUxZmYiLz48cGF0aCBkPSJtMzI4LjQzIDM4MC41NThoMTIwLjgwNXY0NC4zOTJoLTEyMC44MDV6IiBmaWxsPSIjZmQwIi8+PC9nPjwvZz48Zz48cGF0aCBkPSJtMzUuNDYxIDY5LjEwOGMxMC4yOTMgMCAxMC4zMS0xNS40NTMgMC0xNS40NTMtMTAuMjk0IDAtMTAuMzExIDE1LjQ1MyAwIDE1LjQ1M3oiIGZpbGw9IiNmZmYiLz48L2c+PGc+PHBhdGggZD0ibTYzLjEwNCA2OS4xMDhjMTAuMjkzIDAgMTAuMzEtMTUuNDUzIDAtMTUuNDUzLTEwLjI5MyAwLTEwLjMxIDE1LjQ1MyAwIDE1LjQ1M3oiIGZpbGw9IiNmZmYiLz48L2c+PGc+PHBhdGggZD0ibTkwLjc0NyA2OS4xMDhjMTAuMjkzIDAgMTAuMzEtMTUuNDUzIDAtMTUuNDUzLTEwLjI5MyAwLTEwLjMxIDE1LjQ1MyAwIDE1LjQ1M3oiIGZpbGw9IiNmZmYiLz48L2c+PC9nPjwvc3ZnPg==" />
                    <h3>다양한 종류의 디자인</h3>
                    <ul>
                        <li>로그인 팝업, 배너 광고, 모달 팝업 <br>광고, 슬라이딩 광고, 종료 광고 <br>총 5개의 다양한 종류 지원</li>
                        <li>이미지, 동영상 등 형식에 구애받지 <br>않는 디자인</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="section third">
            <div class="wrap-box">
                <div class="box 1" @click="indexChange(0)">로그인 팝업</div>
                <div class="box 2" @click="indexChange(1)">배너 광고</div>
                <div class="box 3" @click="indexChange(2)">모달 팝업 광고</div>
                <div class="box 4" @click="indexChange(3)">슬라이딩 광고</div>
                <div class="box 5" @click="indexChange(4)">종료 광고</div>
            </div>
            <div class="wrap-contents">
                <img :src="datas[index].img" alt="">
                <div class="button_wrap">
                    <button class="arrow" @click="prevButton()" :disabled='index == 0'><i class="fas fa-arrow-left"></i></button>
                    <p>{{datas[index].subject}}</p>
                    <button class="arrow" @click="nextButton()" :disabled='index == datas.length-1'><i class="fas fa-arrow-right"></i></button>
                </div>
                <ul>
                    <li v-for="data in datas[index].explain.length" v-bind:key="data.index"><i class="fas fa-check"></i>&nbsp;&nbsp;&nbsp;&nbsp;{{datas[index].explain[data-1]}}</li>
                </ul>
                
            </div>
            <div>
                
            </div>

        </div>
        <div class="section fourth">
            <div class="mt-5">
                <div id="container">
                    <h4>Contact Us</h4>
                 <form action="#" method="post" id="contact_form">
                    <div class="name">
                    <label for="name"></label>
                    <input type="text" placeholder="성함" name="name" id="name_input" required>
                    </div>
                    <div class="email">
                    <label for="email"></label>
                    <input type="email" placeholder="이메일" name="email" id="email_input" required>
                    </div>
                    <div class="telephone">
                    <label for="name"></label>
                    <input type="text" placeholder="전화번호" name="telephone" id="telephone_input" required>
                    </div>
                    <div class="subject">
                    <label for="subject"></label>
                    <select placeholder="분류" name="subject" id="subject_input" required>
                        <option disabled hidden selected>분류</option>
                        <option>광고 문의</option>
                        <option>제휴 문의</option>
                        <option>기타 문의</option>
                    </select>
                    </div>
                    <div class="message">
                    <label for="message"></label>
                    <textarea name="message" placeholder="간단히 용건을 적어주세요." id="message_input" cols="30" rows="5" required></textarea>
                    </div>
                    <div class="submit d-flex justify-content-around">
                    <input type="submit" value="제 출" id="form_button" />
                    </div>
                </form><!-- // End form -->
                </div>
            </div>
        </div>




    </div>
</template>

<script>
export default {
    data(){
        return{
            subject: undefined,
            img:undefined,
            explain: [],
            index:0,
            datas: [
                {
                    index:1,
                    img: '/static/contact/로그인팝업.PNG',
                    subject: '로그인 팝업',
                    explain:[
                            '엔닷캐드 로그인 시 노출되는 팝업창',
                            '5초 의무 시청 후 팝업 닫기가 가능함',
                            '동영상 적용 가능',
                            '1일 1구좌',
                    ],
                },
                {
                    index:2,
                    img: '/static/contact/배너광고.PNG',
                    subject: '배너 광고',
                    explain:[
                            '엔닷캐드 우측 상단에 고정 노출',
                            '1일 20~30구좌',
                    ],
                },
                {
                    index:3,
                    img: '/static/contact/모달광고.PNG',
                    subject: '모달 팝업 광고',
                    explain:[
                            '엔닷캐드 우측 하단 팝업 노출',
                            '1일 10구좌',
                    ],
                },
                {
                    index:4,
                    img: '/static/contact/슬라이딩광고.PNG',
                    subject: '슬라이딩 광고',
                    explain:[
                            '이메일로 내보내기, STL 내보내기, 버그 신고 등에 노출',
                            '1일 1구좌',
                    ],
                },
                {
                    index:5,
                    img: '/static/contact/종료광고.PNG',
                    subject: '종료 광고',
                    explain:[
                            '엔닷캐드 종료 시 노출되는 팝업창',
                            '5초 의무 시청 후 팝업 닫기가 가능함',
                            '동영상 적용 가능',
                            '1일 1구좌',
                    ],
                },
            ]
        }
    },
    created(){
        this.push(this.index);
    },
    methods:{
        nextButton(){
            this.index = this.index +1;
        },
        prevButton(){
            this.index = this.index -1;
        },
        push(index) {
            this.subject =  this.datas[index].subject
            this.img = this.datas[index].img
            this.explain = this.datas[index].explain
        },
        indexChange(index){
            this.index = index;
        },
        scrollToElement(){
            const el = this.$el.querySelector("#container");
            if (el) {
                el.scrollIntoView({behavior: 'smooth'});
            }
        }
    }
}
</script>

<style scoped>
/* 전체 */
    ul {
        margin: auto;
        text-align: left;
    }
    .section p{
        color: #5E5E5E;
        font-size: 1.05rem;
    }
/* first section */

    .first.section{
        width: 100%;
        padding: 30vh 20vw;
        height: 100vh;
    }

    .first.section img{
        width: 400px
    }

    button {
        margin: 4vh 0;
        background-color: #25CAD2;
        padding: 12px 25px;
        color: white;
        border: none;
        border-radius: 5px;
        font-weight: 700;
    }

    .section h1{
        text-align: left;
        letter-spacing: 0.15rem;
        line-height: 3.5rem;
        font-weight: 700;
        font-size: 2.5rem;
        color: #5E5E5E;
    }
/* second section */

    .second.section{
        /* height: 70vh; */
        /* min-height: 100vh; */
        /* width: 1200px; */
        /* margin: 0 20vw; */
        padding: 20vh 20vw;
        height: 100%;
    }

    .second{
        background-color:#F9F9F9;
        text-align: center;
        padding: 25vh 20vw;
    }

    .second h2{
        font-weight: 700;
        font-size: 1.6rem;
        letter-spacing: 0.15rem;
        margin-bottom: 70px;
    }

    .container{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-around;
        
    }

    .item{
        background-color: white;
        box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.03);
        width: 330px;
        height: 500px;
        border-radius: 40px;
        padding: 5px 20px;
    }

    .item img{
        width: 120px;
        margin: 20px auto;
    }

    .item ul{
        font-size: 0.9rem;
        text-align: left;
        margin-top: 30px;
        list-style-type : circle;
    }

    .bg.item{
        height: 550px;
        padding: 5px 20px;
    }

    .bg.item img{
        width: 150px;
    }

    .numb{
        background-color: #25CAD2;
        border-radius: 20px;
        width: 20%;
        color: white;
        margin: 30px auto;
        padding: 2px;
    }

    /* third section */

    .third.section{
        width: 100%;
        padding: 0;
        margin: 0;
        height: 90vh;
        /* background-color: #FFF9F5; */
    }

    .wrap-box{
        display: flex;
        justify-content: center;
        margin: 0;
        padding: 0;
        width: 100%;
        
    }

    .box{
        border: gray solid 1px;
        padding: 30px;
        margin: 0;
        width: 20%;
        text-align: center;
        cursor: pointer;
        font-weight: 700;
        transition: all 0.3s;
    }

    .box:hover {
    background: #25CAD2;
    /* color: #F2F3EB; */
    /* border: none; */
    }

    .wrap-contects{
        text-align: center;
        width: 100%;
        margin: 30px auto;
         transition: all 0.3s;
    }

    .wrap-contents img{
        display: block;
        /* width: 800px; */
        height: 400px;
        margin: 30px auto;
        /* margin-top: 50px; */
        box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.05);
    }

    .wrap-contents li{
        margin: 10px;
        font-size: 1rem;
    }

    .wrap-contents ul{
        display: table;
        margin-left: auto;
        margin-right: auto;
        padding: 0;
    }

    .button_wrap{
        /* margin-top: 50px; */
        display: flex;
        justify-content: center;
        
    }

    .button_wrap p{
        width: 10%;
        color:  #25CAD2;
        font-weight: 700;
        font-size: 1.1rem;
        margin: 40px 100px;
        text-align: center;
    }

    .arrow{
        color:white;
        border: #25CAD2 solid ;
        -webkit-border-radius: 25px;
        -moz-border-radius: 25px;
        border-radius: 25px;
        width: 30px;
        height: 30px;
        text-align: center;
        display: inline-block;
        cursor: pointer;
        padding: 1px;
    }

/* fourth section */
    .fourth.section{
        height: 100vh;
        width: 100%;
        padding-top: 30px;
        background-color: #F9F9F9;
    }

    #container {
    border: solid 3px #474544;
    max-width: 700px;
    margin: 70px auto;
    position: relative;
    }
    form {
    padding: 37.5px;
    margin: 50px 0;
    }
    h4 {
    color: #474544;
    font-size: 32px;
    font-weight: 700;
    letter-spacing: 7px;
    text-align: center;
    text-transform: uppercase;
    margin-top: 100px;
    }
    .email {
	float: right;
	width: 45%;
    }

    input[type='text'], [type='email'], select, textarea {
        background: none;
    border: none;
        border-bottom: solid 2px #474544;
        color: #474544;
        font-size: 1.000em;
    font-weight: 400;
    letter-spacing: 1px;
        margin: 0em 0 1.875em 0;
        padding: 0 0 0.875em 0;
    text-transform: uppercase;
        width: 100%;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -o-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        -ms-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;
    }

    input[type='text']:focus, [type='email']:focus, textarea:focus {
        outline: none;
        padding: 0 0 0.875em 0;
    }

    .message {
        float: none;
    }

    .name {
        float: left;
        width: 45%;
    }

    select {
    background: url('https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-ios7-arrow-down-32.png') no-repeat right;
    outline: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    }

    select::-ms-expand {
    display: none;
    }

    .subject {
    width: 100%;
    }

    .telephone {
    width: 100%;
    }

    textarea {
        line-height: 150%;
        height: 150px;
        resize: none;
    width: 100%;
    }

    ::-webkit-input-placeholder {
        color: #474544;
    }

    :-moz-placeholder { 
        color: #474544;
        opacity: 1;
    }

    ::-moz-placeholder {
        color: #474544;
        opacity: 1;
    }

    :-ms-input-placeholder {
        color: #474544;
    }

    #form_button {
    background: none;
    border: solid 2px #474544;
    color: #474544;
    cursor: pointer;
    display: inline-block;
    font-size: 0.875em;
    font-weight: bold;
    outline: none;
    padding: 20px 35px;
    text-transform: uppercase;
    -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        -ms-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;
    }

    #form_button:hover {
    background: #474544;
    color: #F2F3EB;
    }

    @media screen and (max-width: 768px) {
    #container {
        margin: 20px auto;
        width: 95%;
    }
    }

    @media screen and (max-width: 480px) {
    h4 {
        font-size: 26px;
    }
    
    .underline {
        width: 68px;
    }
    
    #form_button {
        padding: 15px 25px;
    }
    }

    @media screen and (max-width: 420px) {
    h4 {
        font-size: 18px;
    }
    
    .icon {
        height: 35px;
        width: 35px;
    }
    
    .underline {
        width: 53px;
    }
    
    input[type='text'], [type='email'], select, textarea {
        font-size: 0.875em;
    }
    }
</style>


// WEBPACK FOOTER //
// src/pages/contact_form.vue